import { apiClient } from "../lib/api";

export const policyApi = {
  list: () => apiClient.get("/policies"),
  create: (payload) => apiClient.post("/policies", payload),
  statusByEmployee: (employeeId) => apiClient.get(`/policies/by-employee/${employeeId}/status`),
  acknowledge: (policyId, acknowledgment_text) => apiClient.post(`/policies/${policyId}/acknowledge`, { acknowledgment_text }),
};
